const { getOffsetTop } = window.BAO.Utils

class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    if (window.innerWidth < 768) {
      this.updateEl()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)

    this.els.trigger.element.addEventListener('click', () => {
      if (this.externalEls.variants.element) {
        this.scrollToElement(this.externalEls.variants.element)
      } else {
        this.scrollToElement(this.externalEls.productForm.element)
      }
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    if (window.innerWidth > 900) return

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    if (window.innerWidth > 900) {
      this.setAttribute('aria-hidden', false)
    } else {
      this.setAttribute('aria-hidden', !this.shouldBeVisible)
    }
  }

  scrollToElement (element) {
    const stickyHeader = document.querySelector('.hd-Header_Body')
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0
    const offsetTop = getOffsetTop(element) - stickyHeaderHeight

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    })
  }

  get shouldBeVisible () {
    if (!this.externalEls?.form?.exists) return
    if (window.innerWidth > 900) return false

    const formFooter = this.externalEls.form.element

    if (this.lastKnownY > getOffsetTop(formFooter) + formFooter.offsetHeight) {
      return true
    }

    return false
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
